import * as React from "react";

function isChildOf(possibleParent: Element, element: Element) {
  if (possibleParent === element) {
    return true;
  }

  if (possibleParent.children && possibleParent.children.length > 0) {
    for (let i = 0; i < possibleParent.children.length; i++) {
      const child = possibleParent.children.item(i);
      if (child && isChildOf(child, element)) {
        return true;
      }
    }
  }

  return false;
}

function useOutsideClick(
  refs: Array<React.RefObject<any>>,
  callback: () => void
) {
  React.useEffect(() => {
    const listener = (evt: MouseEvent) => {
      // tslint:disable-next-line:prefer-for-of
      for (let i = 0; i < refs.length; i++) {
        const currentRef = refs[i];

        if (!currentRef.current) {
          continue;
        }

        if (isChildOf(currentRef.current, evt.target as Element)) {
          return;
        }
      }

      callback();
    };

    document.addEventListener("click", listener);

    return () => document.removeEventListener("click", listener);
  });
}

export default useOutsideClick;
